import { CacheStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { LIFECYCLE_FIELD_DESCRIPTORS } from './_lifecycleFields.js';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { COMPONENT } from '../types/component.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for Component entity.
 * Stored in 'org/{orgId}/component'.
 */
export const componentDescriptor = {
    name: COMPONENT,
    label: 'Componente',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/component',
    pathPatternKeys: {
        orgId: 'string',
    },
    version: 1,
    description: 'Component with description and default process',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            description: 'Unique component identifier',
        },
        {
            name: 'code',
            label: 'Código',
            type: 'number',
            required: true,
            unique: true,
            autoNumber: true,
            description: 'Numeric component code (master-data identifier; non-negative, capped at MAX_CODE_SMALL)',
        },
        {
            name: 'description',
            label: 'Descrição',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.NAME,
            description: 'Component description',
        },
        {
            name: 'defaultProcessId',
            label: 'Processo padrão',
            type: 'string',
            required: false,
            description: 'Reference to the default process for this component',
        },
        ...LIFECYCLE_FIELD_DESCRIPTORS,
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [
        ...AUDIT_FOREIGN_KEYS,
        {
            fieldName: 'defaultProcessId',
            targetEntity: 'Process',
            relationship: 'many-to-one',
            description: 'The default process for this component',
            displayField: 'description',
        },
    ],
};
//# sourceMappingURL=component.descriptor.js.map